/**
 * Created by strunz on 05.05.2017.
 */

import {Component, Inject, Input, OnInit, Renderer2} from '@angular/core';
import {StorageService} from '../../services/storage.service';
import {Product} from '../../classes/product';
import {Program} from '../../classes/program';
import {HostListener} from '@angular/core';

@Component({
  selector: 'resultList',
  templateUrl: './resultList.component.html',
  styleUrls: ['./resultList.component.css']
})
export class ResultListComponent implements OnInit {

  itemLoadCount = 9;
  itemCount = this.itemLoadCount;

  @Input() products: Product[] = Array();

  constructor(public storageService: StorageService) {

  };

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const programCount = this.getAllPrograms().length;
    if (this.itemCount < programCount) {
      const itemsToAdd = ((this.itemCount + this.itemLoadCount) > programCount) ? programCount - this.itemCount : this.itemLoadCount;
      if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
        this.itemCount += itemsToAdd;
      }
    }
  }

  ngOnInit(): void {
    this.storageService.resultUpdated$.subscribe(() => {
      this.itemCount = this.itemLoadCount;
    });
  }

  getUrl(program: Program): string {
    return '/' + program.url + '.html';
  }

  private getAllPrograms(): Program[] {
    const allPrograms = Array();
    this.products.forEach(product => {
      product.programs.forEach(program => {
        if (program.showAble) {
          allPrograms.push(program);
        }
      });
    });
    return allPrograms;
  }

  getPrograms(): Program[] {
    const allPrograms = this.getAllPrograms();
    const returnPrograms = Array();
    for (let i = 0; i < this.itemCount; i++) {
      if (allPrograms[i]) {
        returnPrograms.push(allPrograms[i]);
      }
    }
    return returnPrograms;
  }

}
